module.exports = __webpack_public_path__ + "img/2020.f8f2b5ec.jpg";